/**
 *  Module
 *
 * Description: IWO 个人稿库
 * Author:wang.jiang 2016-2-20
 * Modify:wang.jiang 2016-2-21
 */
'use strict';
angular.module('iWoPersonalManuscriptModule', []).controller('iWopersonalManuscriptCtrl', [
    '$scope',
    '$q',
    '$window',
    '$filter',
    'trsHttpService',
    'myManuscriptService',
    'modalDialog',
    'initSingleSelecet',
    'trsspliceString',
    'editingCenterService',
    'iWoService',
    'editcenterRightsService',
    'trsPrintService',
    'localStorageService',
    'storageListenerService',
    'globleParamsSet',
    'iWoConst',
    'newMediaService',
    'publicToolService',
    function personalManuscriptCtrl(
        $scope,
        $q,
        $window,
        $filter,
        trsHttpService,
        myManuscriptService,
        modalDialog,
        initSingleSelecet,
        trsspliceString,
        editingCenterService,
        iWoService,
        editcenterRightsService,
        trsPrintService,
        localStorageService,
        storageListenerService,
        globleParamsSet,
        iWoConst,
        newMediaService,
        publicToolService,
    ) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态
         *
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.data = {
                items: [],
                selectedArray: [], // 已选
                editPath: iWoService.initEditPath(),
                preview: iWoService.initPreviewPath(),
                printResult: [],
                fusionRouter: {
                    // 融合编辑器路由
                    '1': 'fusionnews',
                    '2': 'fusionatlas',
                    '4': 'fusionlinkdoc',
                    '5': 'fusionactivity',
                    '6': 'fusiontopic',
                    '7': 'fusionvideo',
                    '8': 'fusionlive',
                },
            };

            /**
             * [page description:分页信息]
             */
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: globleParamsSet.getPageSize(),
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.dateRangePicker = {};
            $scope.childStatus = {
                // 图片数组的string
                checkString: 'DOC_PICTURELIST',
                // 图片数组中表示url地址的string
                picString: 'PERPICURL',
                originPicUrl: 'SRCPICURL'
            };
            $scope.status = {
                batchOperateBtn: {
                    hoverStatus: '',
                    clickStatus: '',
                },
                personalEdit: 0,
                copyCurrPage: 1,
                btnRights: [], // 权限按钮
                methodname: {
                    1: 'getNewsDoc',
                    2: 'getPicsDoc',
                },
                isESSearch: false, // 是否通过ES检索列表
                hasphoto: false, // 是否是图集稿
                hasphotoflag: true, // 判断是否人为点击图集切换模式
                // imgConcat: false, // 判断是否是图集，进行追加数组
                draftType: {
                    news: '1',
                    atlas: '2',
                    subject: '3',
                    linkDoc: '4',
                    activity: '5',
                    topic: '6',
                    video: '7',
                    live: '8',
                    manuscript: '9',
                    seriesSheet: '11',
                },
                sourceid: '',
                serviceid: {
                    '15': 'mlf_tv',
                    '16': 'mlf_broadcast',
                },
                fusionServiceid: {
                    '15': 'mlf_fusiontv',
                    '16': 'mlf_fusionbroadcast',
                },
            };
            $scope.params = {
                serviceid: 'mlf_releasesource',
                methodname: 'queryPersonalRelease',
                PageSize: $scope.page.PAGESIZE,
                CurrPage: $scope.page.CURRPAGE,
                OperTime: '',
            };
        }

        /**
         * [draftImport description]导入文档
         * @return {[type]} [description]
         */
        $scope.draftImport = function() {
            $scope.status.isESSearch = false;
            $scope.loadingPromise = editingCenterService.draftImport(
                'mlf_extmyrelease',
                'releaseSourceImportDoc',
                '',
                $scope.data.file,
                function() {
                    requestData();
                },
                function() {
                    delete $scope.data.file;
                }
            );
        };

        /**
         * [pageChanged description]下一页
         *
         * @return  {[type]}  [return description]
         */
        $scope.pageChanged = function() {
            $scope.params.CurrPage = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };

        /**
         * [jumpToPage description:跳转指定页面]
         * @return  {[type]}  [return description]
         */
        $scope.jumpToPage = function() {
            if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
            }
            $scope.params.CurrPage = $scope.status.copyCurrPage;
            $scope.page.CURRPAGE = $scope.status.copyCurrPage;
            requestData();
        };

        /**
         * [getESSearchParams description]设置ES检索参数
         * @return {[json]} [description] 参数对象
         */
        function getESSearchParams() {
            var esParams = {
                serviceid: 'mlf_hybasesearch',
                methodname: 'queryForIwoPersonalDoc',
                searchParams: {
                    PAGESIZE: $scope.page.PAGESIZE + '',
                    PAGEINDEX: $scope.page.CURRPAGE + '',
                    searchFields: [
                        {
                            searchField: $scope.iWoAllSelected.value,
                            keywords: $scope.status.keywords ? $scope.status.keywords : '',
                        },
                        {
                            searchField: 'docType',
                            keywords: $scope.data.selectedDocType.value,
                        },
                        {
                            searchField: 'timeType',
                            keywords:
                                angular.isDefined($scope.data.fromdate) && $scope.data.fromdate !== ''
                                    ? $scope.data.fromdate + ',' + $scope.data.untildate
                                    : $scope.timeType.value,
                        },
                        {
                            searchField: '_sort',
                            keywords: $scope.sortType.value,
                        },
                    ],
                },
            };
            esParams.searchParams = JSON.stringify(esParams.searchParams);
            return esParams;
        }

        /**
         * [hasManuscriptOrPlannedOrder description]数组中是否含有广电文稿或串联单
         * @param   {[type]}  arr  [arr description]
         * @return  {[boolean]}       [return description]
         */
        function hasManuscriptOrPlannedOrder(arr) {
            if (arr.length) {
                return false;
            } else {
                return arr.some(function(item) {
                    return item.DOCTYPEID == '9' || item.DOCTYPEID == '11';
                });
            }
        }

        /**
         * [draft description]传稿
         *
         * @return  {[type]}  [return description]
         */
        $scope.draft = function() {
            $scope.status.isESSearch = false;
            $scope.status.batchOperateBtn.clickStatus = 'draft';
            myManuscriptService.draft(
                '传稿',
                angular.copy($scope.data.selectedArray),
                function() {
                    requestData();
                },
                function() {
                    requestData();
                },
                'personalTransferMetaDatas'
            );
        };

        /**
         * [copyBuildDraft description]复制建新稿
         *
         * @return  {[type]}  [return description]
         */
        $scope.copyBuildDraft = function() {
            $scope.status.isESSearch = false;
            if ($scope.data.selectedArray.length === 0) {
                modalDialog.alertType('请选择稿件', '请选择稿件', 'info', false, function() {});
            } else {
                myManuscriptService.copyBuildDraft($scope.data.selectedArray, 'personalCopyBuildDraft', function() {
                    // $scope.selectedArray = [];
                    requestData();
                });
            }
        };

        /**
         * [draftlist description]发稿单
         *
         * @return  {[type]}  [return description]
         */
        $scope.draftlist = function() {
            $scope.status.isESSearch = false;
            $scope.status.batchOperateBtn.clickStatus = 'draftlist';
            if (hasManuscriptOrPlannedOrder($scope.data.selectedArray)) {
                modalDialog.alertType('选中的稿件包含广电文稿和串联单，请重新选择', '', 'info', false);
            } else {
                editingCenterService.draftList(
                    $scope.data.selectedArray,
                    {
                        serviceid: 'mlf_appfgd',
                        methodname: 'iwoPersonbatchUpdateFgdUsers',
                    },
                    function() {
                        $scope.data.selectedArray = [];
                        requestData();
                    }
                );
            }
        };

        /**
         * [singleDraft description:单个传稿]
         * @param  {[type]} item [description:传入稿件]
         * @return  {[type]}  [return description]
         */
        $scope.singleDraft = function(item) {
            $scope.status.isESSearch = false;
            myManuscriptService.draft(
                '传稿',
                [item],
                function() {
                    requestData();
                },
                'personalTransferMetaDatas'
            );
        };

        /**
         * [new description:新建 ]
         * @return  {[type]}  [return description]
         */
        $scope.new = function() {
            $scope.status.batchOperateBtn.clickStatus = 'new';
        };

        /**
         * [more description:更多]
         * @return  {[type]}  [return description]
         */
        $scope.more = function() {
            $scope.status.batchOperateBtn.clickStatus = 'more';
        };

        /**
         * [examDraftType description]检验稿件类型
         * @param  {[obj]} elm [description]稿件的具体信息
         * @return {[type]}     [description]
         */
        $scope.examDraftType = function(elm) {
            if (angular.isDefined(elm)) {
                return elm.DOCTYPEID * 1 !== 1 && elm.DOCTYPEID * 1 !== 2;
            }
        };

        /**
         * [exportDraft description] 导出
         * @return  {[type]}  [return description]
         */
        $scope.exportDraft = function() {
            $scope.status.isESSearch = false;
            var temp = $filter('pick')($scope.data.selectedArray, $scope.examDraftType);
            var docIds = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',')
            $window.open('/wcm/app/file/download_file.jsp?docId=' + docIds);
            $scope.data.selectedArray = [];
            var params = {
                docId:docIds
            };
            trsHttpService.httpServer('/wcm/app/ct/video_info.jsp', params, 'get').then(
                function(data) {
                    if(data.length>0){
                        for(var i =0;i<data.length;i++){
                            $window.open('/transfer/aav/common/download?url=' + data[i]);
                        }
                    }
                }
            )
            // if (temp.length < 1) {
            // if (true) {
            //     var params = {
            //         serviceid: 'mlf_exportword',
            //         methodname: 'exportWordFile',
            //         MetaDataIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
            //     };
            //     console.log(params)
            //     $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
            //         function(data) {
            //             $window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
            //             $scope.data.selectedArray = [];
            //         },
            //         function(data) {
            //             if (data.REPORTS[0].ISSUCCESS == 'true') {
            //                 $window.open('/wcm/app/file/read_file.jsp?FileName=' + data.REPORTS[0].DETAIL);
            //                 $scope.data.selectedArray = [];
            //             }
            //         }
            //     );
            // } else {
            //     modalDialog.alertType('只能导出新闻稿或图集稿', '', 'error', false);
            // }
        };

        /**
         * [selectDraftTip description] 选择稿件提示
         * @return {[boolean]} [description]
         */
        function selectDraftTip() {
            var flag = true;
            if ($scope.data.selectedArray.length === 0) {
                flag = false;
                modalDialog.alertType('请先选择稿件', '', 'warning', 'confirm');
            }
            return flag;
        }

        /**
         * [submit description] 提交
         * @return  {[type]}  [return description]
         */
        $scope.submit = function() {
            $scope.status.isESSearch = false;
            newMediaService.iwoSubmit($scope, 'PersonalSubmitDoc').then(() => {
                $scope.requestData(); // 为了串联单
            });
        };

        /**
         * [departSubmit description] 部门提交
         * @return  {[type]}  [return description]
         */
        $scope.departSubmit = function() {
            $scope.status.isESSearch = false;
            newMediaService.iwoDepartSubmit($scope, 'person');
        };

        /**
         * [initData description] 初始化数据
         * @return  {[type]}  [return description]
         */
        function initData() {
            publicToolService.getModeconfiguration('iwoGongGao').then((config) => {
                $scope.status.iwoGongGao = config;
            });
            editcenterRightsService.initIwoListBtn('iwo.personal').then(function(rights) {
                $scope.status.btnRights = rights;
            });
            initDropDown();
            listenStorage();
        }

        // 用于记忆功能，在app.js中$transitions.onSuccess方法中调用
        $scope.requestData = function() {
            requestData();
        };

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenIwo(function() {
                $scope.status.isESSearch = false;
                requestData();
                storageListenerService.removeListener('iwo');
            }, $scope);
        }

        /**
         * [requestData description]数据请求函数
         *
         * @return  {[type]}  [return description]
         */
        function requestData() {
            var params = $scope.status.isESSearch ? getESSearchParams() : $scope.params;
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                var ListItems = data.DATA;
                $scope.data.items = [];
                $scope.data.items = $scope.data.items.concat(ListItems);
                if ($scope.params.DocType && $scope.params.DocType === '2' && $scope.status.hasphotoflag === true) {
                    $scope.status.hasphoto = true;
                } else {
                    $scope.status.hasphoto = false;
                }
                !!data.PAGER ? ($scope.page = data.PAGER) : ($scope.page.ITEMCOUNT = '0');
                $scope.data.selectedArray = [];
                requestListImg(ListItems).then(function(data) {
                    angular.forEach(ListItems, function(value, key) {
                        value.ALLIMG = data[value.METADATAID];
                    });
                });
                myManuscriptService.getDraftRelatedInfo($scope);
                // getRelatedMediaIds(1)
                //     .then((data) => {
                //         getRelatedInfo(ListItems);
                //     })
                //     .then((data) => {
                //         angular.forEach(ListItems, function(value, key) {
                //             value.relatedInfo = data[value.METADATAID];
                //         });
                //     });
                localStorageService.remove('iWo');
            });
            $scope.status.imgConcat = false;
        }

        /**
         * [atlasMode description] 图集模式
         * @return {[type]} [description]
         */
        $scope.atlasMode = function() {
            $scope.status.hasphoto = !$scope.status.hasphoto;
            $scope.status.hasphotoflag = !$scope.status.hasphotoflag;
        };

        /**
         * [requestListImg description] 请求图示
         * @param   {[array]}  items  [items description] 请求图示
         * @return  {[type]}          [return description]
         */
        function requestListImg(items) {
            var defer = $q.defer();
            if (!items || items.length < 1) {
                defer.resolve([]);
            } else {
                var params = {
                    serviceid: 'mlf_myrelease',
                    methodname: 'queryAllImgLogo',
                    metadataids: trsspliceString.spliceString(items, 'METADATAID', ','),
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    defer.resolve(data);
                });
            }
            return defer.promise;
        }

        /**
         * [getRelatedInfo description] 获取关联信息
         * @param  {[type]} items [description] 稿件items
         * @return {[type]}       [description]
         */
        function getRelatedInfo(items) {
            let defer = $q.defer();
            if (!items || items.length < 1) {
                defer.resolve([]);
            } else {
                let params = {
                    serviceid: 'mlf_fusioncreate',
                    methodname: 'queryFuseMappingsByDocIds',
                    sourceDocIds: trsspliceString.spliceString(items, 'METADATAID', ','),
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    defer.resolve(data);
                });
            }
            return defer.promise;
        }

        /**
         * [selectAll description] 全选
         * @return  {[type]}  [return description]
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
            cancelBatchOperate();
        };

        /**
         * [selectDoc description] 单选
         * @param   {[object]}  item  [item description] 稿件信息
         * @return  {[type]}          [return description]
         */
        $scope.selectDoc = function(item) {
            if ($scope.data.selectedArray.indexOf(item) < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice($scope.data.selectedArray.indexOf(item), 1);
            }
            cancelBatchOperate();
        };

        /**
         * [cancelBatchOperate description] 取消批量操作的样式
         * @return  {[type]}  [return description]
         */
        function cancelBatchOperate() {
            if ($scope.data.selectedArray.length === 0) {
                $scope.status.batchOperateBtn = {
                    hoverStatus: '',
                    clickStatus: '',
                };
            }
        }

        /**
         * [supply description] 供稿方法
         * @return  {[type]}  [return description]
         */
        $scope.supply = function() {
            editingCenterService
                .feedPopup({
                    manuscripts: $scope.data.selectedArray,
                    mediaType: '-1',
                    oprType: 'personal',
                })
                .then(function(data) {
                    modalDialog.multiReportsAlert(data, function() {
                        requestData();
                    });
                });
        };

        /**
         * [batchShare description] 稿件共享
         * @return  {[type]}            [return description]
         */
        $scope.batchShare = function() {
            $scope.status.isESSearch = false;
            newMediaService.iwoShare($scope, iWoConst.personalShare);
        };

        /**
         * [outSending description] 外发
         * @return  {[type]}  [return description]
         */
        $scope.outSending = function() {
            if (!selectDraftTip()) {
                return;
            }
            $scope.status.isESSearch = false;
            editingCenterService.outSending('', function(result) {
                outSendingDraft(result.selectItems);
            });
        };

        /**
         * [outSendingDraft description] 稿件外发
         * @param   {[type]}  items  [items description]
         * @return  {[type]}         [return description]
         */
        function outSendingDraft(items) {
            var userids = trsspliceString.spliceString(items, 'EMAIL', ',');
            var draftids = trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ',');
            var params = {
                serviceid: 'mlf_mailoutgoingOper',
                methodname: 'iPersonSendEmail',
                Emails: userids,
                MetaDataIds: draftids,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                modalDialog.alertType('稿件外发成功！', '', 'success', false, function() {
                    requestData();
                });
            });
        }

        /**
         * [deleteManuscript description] 废稿方法
         * @param   {[type]}  chnlDocIdsArray  [chnlDocIdsArray description]
         * @param   {[type]}  content          [content description]
         * @return  {[type]}                   [return description]
         */
        function deleteManuscript(chnlDocIdsArray, content) {
            var params = {
                serviceid: 'mlf_fusionmyrelease',
                methodname: 'scrapMyRelease',
                ChnlDocIds: chnlDocIdsArray,
                Opinion: content,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                modalDialog.alertType('废稿成功！', '', 'success', false);
                requestData();
            });
        }

        /**
         * [batchDelete description] 批量废稿
         * @return  {[type]}  [return description]
         */
        $scope.batchDelete = function() {
            if (!selectDraftTip()) {
                return;
            }
            $scope.status.isESSearch = false;
            modalDialog.inputModel('废稿', '废稿原因（可选）', function(content) {
                var chnlDocIdsArray = trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ',');
                deleteManuscript(chnlDocIdsArray, content);
            });
        };

        /**
         * [archive description] 手动归档
         * @return {[type]} [description]
         */
        $scope.archive = function() {
            modalDialog.confirmModal('归档', '确定归档？', function() {
                var params = {
                    serviceid: 'mlf_fusionmyrelease',
                    methodname: 'manualRecordDoc',
                    ChnlDocIds: trsspliceString.spliceString($scope.data.selectedArray, 'CHNLDOCID', ','),
                };
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(
                    function(data) {
                        modalDialog.alertType('归档成功！', '', 'success', false, function() {
                            requestData();
                        });
                    },
                    function() {
                        requestData();
                    }
                );
            });
        };

        /**
         * [printBtn description] 打印
         * @return  {[type]}  [return description]
         */
        $scope.printBtn = function() {
            if (!selectDraftTip()) {
                return;
            }
            $scope.status.isESSearch = false;
            if (!allowPrint()) {
                modalDialog.alertType('只能打印新闻、图集、串联单、广电文稿', '', 'warning', 'confirm');
                return;
            }
            if (!hasBroadcastManuscript()) {
                // 判断是否只有广电广电文稿和串联单
                if (hasNewsAndPicture()) {
                    // 是否为纯新闻和图集稿
                    angular.forEach($scope.data.selectedArray, function(value, key) {
                        requestPrintData(value);
                    });
                } else {
                    modalDialog.alertType('只能单独打印串联单和广电文稿', '', 'warning', 'confirm');
                    return;
                }
            } else {
                angular.forEach($scope.data.selectedArray, function(value, key) {
                    getBroadcastData(value, value.DOCTYPEID);
                });
            }

            /**
             * [allowPrint description] 是否允许打印
             * @return {[boolean]} [description]
             */
            function allowPrint() {
                var flag = true;
                for (var i in $scope.data.selectedArray) {
                    var item = $scope.data.selectedArray[i];
                    if (item.DOCTYPEID !== '1' && item.DOCTYPEID !== '2' && item.DOCTYPEID !== '9' && item.DOCTYPEID !== '11') {
                        flag = false;
                        break;
                    }
                }
                return flag;
            }
        };

        /**
         * [hasBroadcastManuscript 判断是否包含广电广电文稿和串联单]
         * @return {Boolean} [description]
         */
        function hasBroadcastManuscript() {
            var flag;
            flag = $scope.data.selectedArray.every(function(item, index, array) {
                return item.DOCTYPEID == '9' || item.DOCTYPEID == '11';
            });
            return flag;
        }

        /**
         * [hasBroadcastManuscript 是否包含新闻、图集]
         * @return {Boolean} [description]
         */
        function hasNewsAndPicture() {
            var flag;
            flag = $scope.data.selectedArray.every(function(item, index, array) {
                return item.DOCTYPEID * 1 === 1 || item.DOCTYPEID * 1 === 2;
            });
            return flag;
        }

        /**
         * [queryChannelForMetadataid description] 查询串联单所属渠道
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        function queryChannelForMetadataid(item) {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_fusioncreate',
                methodname: 'queryDocMediaType',
                ObjectId: item.METADATAID,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                $scope.status.sourceid = data.MSG;
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [getBroadcastData 获取稿件详情]
         * @param  {[type]} item [description]
         * @param  {[type]} type [description]
         * @return {[type]}      [description]
         */
        function getBroadcastData(item, type) {
            if (type * 1 === 9) {
                var params = {
                    serviceid: 'mlf_fusiontv',
                    methodname: 'getVirtualWenGaoDoc',
                    SourceDocId: item.METADATAID,
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                    var result = data;
                    data.PLATFORM = 'iwo';
                    // data.VERSION = version;
                    // data.HANGCOUNT = Math.ceil(data.DOCWORDSCOUNT / 27);
                    $scope.data.printResult.push(result);
                    if ($scope.data.printResult.length == $scope.data.selectedArray.length) {
                        trsPrintService.trsTvPrintDocument($scope.data.printResult);
                        $scope.data.printResult = [];
                    }
                });
            } else {
                queryChannelForMetadataid(item).then(function() {
                    var params = {
                        serviceid: $scope.status.fusionServiceid[$scope.status.sourceid],
                        methodname: 'getVirtualChuanLianDoc',
                        SourceDocId: item.METADATAID,
                    };
                    $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                        getSeriessheetList(data);
                    });
                });
            }
        }

        /**
         * [getSeriessheetList description] 获取串联单关联稿件
         * @param   {[type]}  result  [result description]
         * @return  {[type]}          [return description]
         */
        function getSeriessheetList(result) {
            var params = {
                serviceid: 'mlf_tv',
                methodname: 'queryQuoteDocListsToJSON',
                SeriesDocId: result.METADATAID,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                result.ITEMS = data;
                $scope.data.printResult.push(result);
                if ($scope.data.printResult.length === $scope.data.selectedArray.length) {
                    trsPrintService.trsTvPrintDocument($scope.data.printResult);
                    $scope.data.printResult = [];
                }
            });
        }

        /**
         * [requestPrintData description] 打印请求详情
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        function requestPrintData(item) {
            var params = {
                serviceid: 'mlf_myrelease',
                methodname: $scope.status.methodname[item.DOCTYPEID],
                MetaDataId: item.METADATAID,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                var result = data;
                data.HANGCOUNT = Math.ceil(data.DOCWORDSCOUNT / 27);
                $scope.data.printResult.push(result);
                if ($scope.data.printResult.length == $scope.data.selectedArray.length) {
                    trsPrintService.trsIwoPrintDocument($scope.data.printResult);
                    $scope.data.printResult = [];
                }
            });
        }

        /**
         * [singleDelete description] 单个删除
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.singleDelete = function(item) {
            $scope.status.isESSearch = false;
            modalDialog.inputModel('是否确认废除稿件', '废除稿件原因（可选', function(content) {
                deleteManuscript(item.CHNLDOCID, content);
            });
        };

        /**
         * [getDraft description：取单传稿件 多选]
         * @param  {[type]} item [description：稿件对象]
         * @return {[type]}      [description]
         */
        $scope.getDraft = function(item) {
            $scope.status.isESSearch = false;
            $scope.status.batchOperateBtn.clickStatus = 'getDraft';
            var array = angular.copy($scope.data.selectedArray);
            var service = [{
                type: '传稿',
                serviceid: 'mlf_myrelease',
                methodname: 'queryRecentTransferedDoc',
                darftservice: 'personalGetRecentTransferedDoc'
            },{
                type: '部门提交',
                serviceid: 'mlf_departoperdoc',
                methodname: 'queryRecentTransferedDoc',
                darftservice: 'pGetRecentTransferedDoc'
            }];
            myManuscriptService.getDraft(array, service, function(data) {
                requestData();
            });
        };

        /**
         * [initDropDown description]初始化下拉框
         *
         * @return  {[type]}  [return description]
         */
        function initDropDown() {
            // 初始化选择日期
            $scope.timeTypeJsons = initSingleSelecet.iWoOperTime();
            $scope.timeType = angular.copy($scope.timeTypeJsons[0]);
            // 初始状态
            $scope.iWoDocStatusName = initSingleSelecet.iWoDocType();
            $scope.data.selectedDocType = angular.copy($scope.iWoDocStatusName[0]);
            // 初始化全部
            $scope.iWoAll = initSingleSelecet.iWoEntire();
            $scope.iWoAllSelected = angular.copy($scope.iWoAll[0]);
            // 排序方式
            $scope.sortTypeJsons = initSingleSelecet.sortType();
            $scope.sortType = angular.copy($scope.sortTypeJsons[1]);
            // editingCenterService.dealStorage($scope);
        }

        /**
         * [selectPageNum description]选择单页显示个数
         *
         * @return  {[type]}  [return description]
         */
        $scope.selectPageNum = function() {
            $scope.params.PageSize = $scope.page.PAGESIZE;
            $scope.params.CurrPage = $scope.page.CURRPAGE;
            $scope.status.copyCurrPage = 1;
            requestData();
        };

        /**
         * [queryByDropdown description] 筛选条件触发后请求数据
         * @param  {[type]} key   [description] 请求对象参数key
         * @param  {[type]} value [description] 请求对象值
         * @return {[type]}       [description] null
         */
        $scope.queryByDropdown = function(key, value) {
            $scope.params[key] = value;
            $scope.params.CurrPage = $scope.status.copyCurrPage = $scope.page.CURRPAGE = '1';
            if (key === 'OperTime') {
                $scope.params[key] = null;
                $scope.params.OperTimeStart = $scope.data.fromdate;
                $scope.params.OperTimeEnd = $scope.data.untildate;
            }
            if (key === 'DocType' && value === '2') {
                $scope.status.hasphotoflag = true;
            }
            requestData();
        };

        /**
         * [showVersionTime description] 流程版本时间与操作日志
         * @param   {[object]}  item  [item description] 稿件信息
         * @return  {[type]}          [return description]
         */
        $scope.showVersionTime = function(item) {
            editingCenterService.getVersionTime(item, true);
        };

        /**
         * [fullTextSearch description] 全文检索
         * @param   {[object]}  ev  [ev description] 事件对象
         * @return  {[type]}        [return description]
         */
        $scope.fullTextSearch = function(ev) {
            if ((angular.isDefined(ev) && ev.keyCode == 13) || angular.isUndefined(ev)) {
                $scope.status.isESSearch = true;
                $scope.page.CURRPAGE = 1;
                requestData();
            }
        };

        /**
         * [mergeToAtlas description] 合并成图集
         * @return {[type]} [description]
         */
        $scope.mergeToAtlas = function() {
            if (!selectDraftTip()) {
                return;
            }
            $scope.status.isESSearch = false;
            var hasUnAtlas = $filter('some')($scope.data.selectedArray, "DOCTYPEID!=='2'");
            if ($scope.data.selectedArray.length === 1) {
                modalDialog.alertType('单篇稿件不允许合并', '', 'error', 'confirm', function() {});
                return;
            }
            if (hasUnAtlas) {
                modalDialog.alertType('选中的稿件包含非图集稿', '', 'error', 'confirm', function() {});
            } else {
                var params = {
                    serviceid: 'mlf_fusionmyrelease',
                    methodname: 'mergePicDocsOfPersonal',
                    MetaDataIds: trsspliceString.spliceString($scope.data.selectedArray, 'METADATAID', ','),
                };
                $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
                    modalDialog.alertType('图集合并成功！', '', 'success', false, function() {
                        requestData();
                    });
                });
            }
        };

        /**
         * [fusionPreview description] 融合编辑 预览
         * @param   {[type]}  item           [item description]
         * @return  {[type]}                 [return description]
         */
        $scope.fusionPreview = function(item) {
            myManuscriptService.fusionPreviewRouter(item, $scope);
        };

        /**
         * [fusionEditor description] 融合编辑
         * @param   {[type]}  item           [item description]
         * @return  {[type]}                 [return description]
         */
        $scope.fusionEditor = function(item) {
            myManuscriptService.fusionRouter(item, $scope);
        };

        /**
         * [manuscriptShare description] 稿件分享
         * @return {[type]} [description]
         */
        /**
         * [manuscriptShare description] 稿件分享
         * @param   {[object]}  item  [item description]
         * @return  {[type]}          [return description]
         */
        $scope.manuscriptShare = function(item) {
            $scope.loadingPromise = editingCenterService.manuscriptShare(item, function(data) {
                requestData();
            });
        };

        // /**
        //  * [getRelatedMediaIds description] 获取关联渠道的相关id
        //  * @param {[type]} [doctype] [description] 稿件类型
        //  * @return {[type]} [description]
        //  */
        // function getRelatedMediaIds(doctype) {
        //     var defer = $q.defer();
        //     var params = {
        //         serviceid: 'mlf_fusioncreate',
        //         methodname: 'getMediaTypesByDocType',
        //         doctype: doctype,
        //     };
        //     trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'get').then(function(data) {
        //         $scope.status.relatedChannelInfos = data;
        //         defer.resolve(data);
        //     });
        //     return defer.promise;
        // }


        /**
         * [getRelatedMediaIcon description] 获取相关媒体的icon字
         * @param  {[type]} relatedMedia [description]
         * @return {[type]}              [description]
         */
        $scope.getRelatedMediaIcon = function(relatedMedia) {
            iWoService.getRelatedMediaIcon(relatedMedia);
        };

        /**
         * [goToDetail description] 图集模式跳转
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.goToDetail = function(item){
            $scope.fusionPreview(item);
        };
    },
]);
